/* KOMTO redesign (BAN-179): the mobile menu drawer (M-04).
 * - "By room" / "By category" tabs: arrow keys move between them, the selected tab shows its list.
 * - The announcement bar's script moves the country and language selectors into the drawer on
 *   phones; they are placed in the drawer's bottom bar next to "Log in".
 */
(() => {
  const nav = document.querySelector('[data-komto-mnav]');
  if (!nav || nav.dataset.ready) return;
  nav.dataset.ready = 'true';
  nav.classList.add('komto-mnav--js');

  const tabs = Array.from(nav.querySelectorAll('[data-komto-mnav-tab]'));
  const select = (tab, focus) => {
    tabs.forEach((t) => {
      const on = t === tab;
      t.setAttribute('aria-selected', on ? 'true' : 'false');
      t.tabIndex = on ? 0 : -1;
      const panel = document.getElementById(t.getAttribute('aria-controls'));
      if (panel) panel.toggleAttribute('data-komto-mnav-hidden', !on);
    });
    if (focus) tab.focus();
  };
  tabs.forEach((tab, i) => {
    tab.addEventListener('click', () => select(tab, false));
    tab.addEventListener('keydown', (event) => {
      let next = null;
      if (event.key === 'ArrowRight') next = tabs[(i + 1) % tabs.length];
      if (event.key === 'ArrowLeft') next = tabs[(i - 1 + tabs.length) % tabs.length];
      if (event.key === 'Home') next = tabs[0];
      if (event.key === 'End') next = tabs[tabs.length - 1];
      if (next) {
        event.preventDefault();
        select(next, true);
      }
    });
  });

  const bottom = nav.querySelector('[data-komto-mnav-bottom]');
  const content = nav.closest('.main-menu__content');
  if (!bottom || !content) return;
  const placeLocalization = () => {
    const loc = content.querySelector(':scope > .mob__localization');
    if (loc) bottom.appendChild(loc);
  };
  placeLocalization();
  new MutationObserver(placeLocalization).observe(content, { childList: true });
})();

/* Phones: the search row folds away while the page scrolls down and comes back on the way up,
 * so the sticky header is one 60 px row (Mobile-Sticky). --header-end follows, because the
 * product page's section rail and the menu drawer sit under the header. */
(() => {
  const header = document.querySelector('store-header.komto-header');
  if (!header || header.dataset.komtoCompact) return;
  header.dataset.komtoCompact = 'true';
  const phone = window.matchMedia('(max-width: 768.98px)');
  const setEnd = () => {
    const end = header.getBoundingClientRect().bottom;
    if (end > 0) document.documentElement.style.setProperty('--header-end', `${end.toFixed(1)}px`);
  };
  let last = window.scrollY;
  let ticking = false;
  const update = () => {
    ticking = false;
    const y = window.scrollY;
    const busy = header.contains(document.activeElement) || document.body.classList.contains('overflow-hidden');
    let compact = header.classList.contains('komto-header--compact');
    if (!phone.matches || y < 160) compact = false;
    else if (!busy && y > last + 6) compact = true;
    else if (y < last - 6) compact = false;
    if (compact !== header.classList.contains('komto-header--compact')) {
      if (compact) {
        // Keep the page where it is: the folded row's height stays as a bottom margin,
        // the way Enterprise folds the nav row on desktop.
        const search = header.querySelector('.header__search');
        const shift = (search ? search.offsetHeight : 44) + parseFloat(getComputedStyle(header).paddingBottom || 0);
        header.style.setProperty('--komto-compact-shift', `${shift}px`);
      }
      header.classList.toggle('komto-header--compact', compact);
    }
    last = y;
  };
  window.addEventListener('scroll', () => {
    if (!ticking) {
      ticking = true;
      requestAnimationFrame(update);
    }
  }, { passive: true });
  header.addEventListener('transitionend', (event) => {
    if (event.target.classList && event.target.classList.contains('header__search')) setEnd();
  });
  phone.addEventListener('change', () => {
    header.classList.remove('komto-header--compact');
  });
})();
